export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f3b6776b89e4a301a3104cf1d6240be9f4f831773&name=fetchTypeahead!'